import { actions, mutations } from "@/constants/state";
import { getEmployeeTags } from "@/services/employee-tag-service";

export default {
  [actions.EMPLOYEE_TAGS_FETCH_ACTION]: async ({ commit }, { from, until }) => {
    const { data } = await getEmployeeTags(from, until);
    commit(mutations.EMPLOYEE_TAGS_FETCH_MUTATION, data);
  },
};
